<template>
	<div class="js-comments">
		<form class="comments__form fadeIn" @submit.prevent="onSubmit" id="add-comment-form" name="add-comment-form">
			<fieldset>
				<legend>
					<span class="type-label">How did you experience this show?</span>
				</legend>
				<div class="form-group form-group--radio">
				  <input
            type="radio"
            id="comment-experience-saw"
            name="comment-Experience"
            class="input-radio"
            data-vv-as="review experience"
            v-validate="'required'"
             value="saw"
            data-vv-validate-on="input"
            v-model="formValues.Experience"/>
				  <label
            class="type-label type-normal" for="comment-experience-saw">I saw it</label>
				</div>
				<div class="form-group form-group--radio">
				  <input
            type="radio"
            id="comment-experience-read"
            name="comment-Experience"
            class="input-radio"
            value="read"
            data-vv-validate-on="input"
            v-model="formValues.Experience"/>
				  <label class="type-label type-normal" for="comment-experience-read">I read it</label>
				</div>
				<div class="form-group form-group--radio">
				  <input
            type="radio"
            id="comment-experience-produced"
            name="comment-Experience"
            class="input-radio"
            value="produced"
            data-vv-validate-on="input"
            v-model="formValues.Experience"/>
				  <label class="type-label type-normal" for="comment-experience-produced">I produced it</label>
				</div>
				<div class="form-group form-group--radio">
				  <input
            type="radio"
            id="comment-experience-performed"
            name="comment-Experience"
            class="input-radio"
            value="performed"
            data-vv-validate-on="input"
            v-model="formValues.Experience"/>
				  <label class="type-label type-normal" for="comment-experience-performed">I performed it</label>
				</div>
				<div class="form-group form-group--radio">
				  <input
            type="radio"
            id="comment-experience-worked"
            name="comment-Experience"
            class="input-radio"
            value="worked"
            data-vv-validate-on="input"
            v-model="formValues.Experience"/>
				  <label class="type-label type-normal" for="comment-experience-worked">I worked on it</label>
				</div>
				<span class="input-help-text color-red" v-show="errors.has('comment-Experience')">{{ errors.first('comment-Experience') }}</span>
			</fieldset>
			<fieldset>
				<legend class="type-label">How would you describe this show?</legend>
				<p class="type-small">Select up to three words that best describe your experience.</p>
				<div class="flex flex-wrap pill-container">
          <div class="form-group form-group--checkbox pill-box" v-for="option in tagOptions">
						<input
              type="checkbox"
              class="input-checkbox input-checkbox--pill"
              name="show-description"
              :id="`show-description--${option}`"
              :value="option"
              :disabled="formValues.Tags.length >= 3 && formValues.Tags.indexOf(option) === -1"
              v-model="formValues.Tags">
						<label
              class="pill"
              :for="`show-description--${option}`"
              >{{ option }}</label>
					</div>
          <!-- <span class="input-help-text color-red" v-show="errors.has('show-description')">{{ errors.first('comment-Connection') }}</span> -->
				</div>
			</fieldset>
			<div class="form-group">
				<label>
					<span class="type-label">Give your experience a title *</span>
					<input type="text" placeholder="Title" id="comment-ReviewTitle" name="comment-ReviewTitle" data-vv-as="title" v-validate="'required'" :class="{'error': errors.has('comment-ReviewTitle') }" v-model="formValues.ReviewTitle">
					<span class="input-help-text color-red" v-show="errors.has('comment-ReviewTitle')">{{ errors.first('comment-ReviewTitle') }}</span>
				</label>
			</div>
			<div class="form-group">
				<label>
					<span class="type-label">Tell us about your experience *</span>
					<textarea id="comment-ReviewText" name="comment-ReviewText" v-model="formValues.ReviewText" data-vv-as="description" v-validate="'required'" :class="{'error': errors.has('comment-ReviewText') }" placeholder="Share your latest experiences"></textarea>
					<span class="input-help-text color-red" v-show="errors.has('comment-ReviewText')">{{ errors.first('comment-ReviewText') }}</span>
				</label>
			</div>
			<fieldset class="fieldset--small">
				<legend class="sr" aria-describedby="comment-name-description">Name</legend>
				<div class="form-group form-group--inline">
					<label>
						<span class="type-label">First Name</span>
						<input type="text" placeholder="Name" id="comment-FirstName" name="comment-FirstName" v-model="formValues.FirstName">
					</label>
				</div>
				<div class="form-group form-group--inline">
					<label>
						<span class="type-label">Last Initial</span>
						<input type="text" placeholder="Initial" id="comment-LastInitial" name="comment-LastInitial" v-model="formValues.LastInitial">
					</label>
				</div>
				<p class="input-help-text" id="comment-name-description">If you do not submit a name here, your experience will be submitted as anonymous.</p>
			</fieldset>
			<div class="form-group">
				<label for="comment-Connection">
					<span class="type-label">Connection to Theatre *</span>
				</label>
				<select name="comment-Connection" id="comment-Connection" v-validate="'required'" data-vv-as="connection" v-model="formValues.Connection" :class="{'disabled' : formValues.Connection == ''}">
					<option value="" disabled="disabled" selected>Select Connection to Theatre</option>
					<option
            v-for="option in theatreConnections"
            :value="option">
            {{ option }}
          </option>
				</select>
				<span class="input-help-text color-red" v-show="errors.has('comment-Connection')">{{ errors.first('comment-Connection') }}</span>
			</div>
			<div class="form-group form-group--submit">
				<button type="submit" class="btn btn--small" :class="{ 'btn--disabled' : !formIsValid }"  :disabled="!formIsValid">{{ buttonText }}</button>
				<button type="button" class="btn btn--secondary btn--small" @click="cancel">Cancel</button>
			</div>
		</form>
	</div>
</template>

<script>
	import { mapState } from 'vuex';
	import { mapActions } from 'vuex';
	// import format from 'date-fns/format';
  const commentFormName = 'add-comment-form';
  import { FETCH_COMMENTS } from '../vuex/modules/comments/mutations';
	import { POST_COMMENT } from '../vuex/modules/comments/mutations';
	import { UPDATE_COMMENT } from '../vuex/modules/comments/mutations';
	// import { POST_COMMENT } from '../store/mutation-types';
  // import { UPDATE_COMMENT } from '../store/mutation-types';

  import _ from 'lodash';

	export default {
		name: 'CommentForm',
		props: ['productId', 'currentComment'],
		data() {
			return {
				formIsValid: true,
				buttonText: 'Share my experience',
				formValues: {
          Experience: '',
          CustomerId: null,
					Tags: [],
					ReviewTitle:'',
					ReviewText:'',
					FirstName:'',
					LastInitial:'',
					Connection:'',
					Pending: '',
					Id: null,
        },
        tagOptions: [
          'Action-packed',
          'Ambitious',
          'Candid',
          'Challenging',
          'Controversial',
          'Dark',
          'Diverse',
          'Dynamic',
          'Educational',
          'Entertaining',
          'Family friendly',
          'Flexible',
          'Heartbreaking',
          'Hilarious',
          'Impactful',
          'Inspiring',
          'Intense',
          'Magical',
          'Mature',
          'Memorable',
          'Offbeat',
          'Realistic',
          'Refreshing',
          'Smart',
          'Stunning',
          'Surreal',
          'Thought-provoking',
          'Timeless',
          'Unconventional',
          'Unique',
        ],
        theatreConnections: [
          'Actor',
          'Administrator',
          'Artistic Director',
          'Designer/Technician',
          'Playwright',
          'Director',
          'Student',
          'Teacher',
          'Theatre Lover',
          'Audience Member',
        ]
			}
		},
		mounted() {

      if( this.isLoggedIn ){
        this.formValues.CustomerId = this.customer.Id;
      }

    },

    watch: {
      isEditing() {
        // console.log('updated');
        if( !_.isEmpty(this.commentEdit.comment) ) {
          // console.log('is editing');
          this.buttonText = 'Update my experience';

          // set local state from Props
          this.formValues.Experience = this.currentComment.Experience;
          this.formValues.Tags = this.currentComment.Tags;
          this.formValues.ReviewTitle = this.currentComment.ReviewTitle;
          this.formValues.ReviewText = this.currentComment.ReviewText;
          this.formValues.FirstName = this.currentComment.FirstName;
          this.formValues.LastInitial = this.currentComment.LastInitial;
          this.formValues.Connection = this.currentComment.Connection;
          this.formValues.Pending = this.currentComment.Pending || null;
          this.formValues.Id = this.currentComment.Id || null;
          this.formValues.CustomerId = this.currentComment.CustomerId || null;
        }else{
          this.formValues.Experience = '';
          this.formValues.Tags = [];
          this.formValues.ReviewTitle = '';
          this.formValues.ReviewText = '';
          this.formValues.FirstName = '';
          this.formValues.LastInitial = '';
          this.formValues.Connection = '';
          this.formValues.Pending = '';
          this.formValues.Id = null;
          this.formValues.CustomerId = null;
        }
      }
    },
    methods: {
    	...mapActions({
				POST_COMMENT,
        UPDATE_COMMENT,
        FETCH_COMMENTS,
			}),

			validateForm() {
         return new Promise((resolve, reject) => {
           // there was a bug, fix here: https://github.com/baianat/vee-validate/issues/592#issuecomment-310869873
           this.$validator.validateAll().then((result) => {
            if(!result){
              // console.log(this.errors);
              const firstItem = document.querySelector(`[name="${this.errors.items[0].field}"]`);
              firstItem.focus();
              reject(result, 'form invalid');
            }
            resolve('no errors');
          }).catch((err) => {
            reject(err)
          });

        })
      },

			async onSubmit() {
        const isValid = await this.validateForm().catch(error => console.log(error));
        if( isValid == 'no errors' ){
          this.postCommentData(this.formValues);
        }
      },

			postCommentData(data) {
        // if form field is empty, set to anonymous
        if( data.FirstName == '' ){
          data.FirstName = 'Anonymous';
        }
				if( this.currentComment.ReviewTitle ) {
          this.UPDATE_COMMENT(data)
            .then( () => {
              this.FETCH_COMMENTS()
            })
				}else{
          this.POST_COMMENT(data)
            .then( () => {
              this.FETCH_COMMENTS()
            })
				}
				this.$emit('formSubmit'); // toggles the form/comments list visiblity
			},
			cancel() {
				this.$emit('cancel-comment');
			}

		},
		computed: {
			...mapState({
        comments: state => state.commentsModule.comments,
        isLoggedIn: state => state.AuthStore.isLoggedIn,
        customer: state => state.AuthStore.customer,
        commentEdit: state => state.commentsModule.commentEdit,
        isEditing: state => state.commentsModule.commentEdit.isEditing,
			}),
		},
	}
</script>


// WEBPACK FOOTER //
// resources/assets/js/components/CommentForm.vue